import { render } from "./add_language_component.vue?vue&type=template&id=010c1519&scoped=true"
import script from "./add_language_component.vue?vue&type=script&lang=js"
export * from "./add_language_component.vue?vue&type=script&lang=js"

import "./add_language_component.vue?vue&type=style&index=0&id=010c1519&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010c1519"]])

export default __exports__